import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PeripheralLimitGroup from './PeripheralLimitGroup'
import { updateEntityAction, deleteDoorAction } from 'actions/entityActions'
import { ACCESS_REVERSE_MAP } from 'helpers/globals'
import tippy from 'tippy.js'

function mapStateToProps(state, ownProps) {
  const { entities: { doors: { byId } }, currentEntity } = state

  return {
    currentDoor: byId[ownProps.id],
    highlight: currentEntity.type === 'door' && currentEntity.id === ownProps.id
  }
}

class DoorConfiguration extends React.Component {
  componentDidMount = _ => this.props.currentDoor.locked && tippy(this.refs.deleteDoor, { duration: 0, theme: 'topbar', placement: 'top', hideOnClick: false, onShow: instance => this.tooltip = instance })

  componentWillUnmount = _ => this.tooltip && this.tooltip.hide()

  render() {
    const { id, currentDoor, model, usages, totals, gridColumn, highlight, updateEntityAction, deleteDoorAction, classes } = this.props

    if (!currentDoor) return <div className={classes.config} />

    return (
      <div className={classes.config}>
        <div className={classes.nameWrapper + (gridColumn % 2 === 0 ? ' even' : ' odd')} style={{ gridColumn, gridRow: 1 }}>
          <span title='Name'>Name:</span>
          <input
            type='text'
            onChange={({ target: { value } }) => updateEntityAction('doors', currentDoor.id, { name: value })}
            value={currentDoor.name || ''}
          />
          <a
            onClick={_ => !currentDoor.locked && deleteDoorAction(id)}
            className={classes.removeIcon + (currentDoor.locked ? ' disabled' : '')}
            title={currentDoor.locked ? 'Cannot delete locked door' : ''}
            ref='deleteDoor'
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        { Object.keys(ACCESS_REVERSE_MAP).map((limitType, index) =>
            <PeripheralLimitGroup
              limitType={limitType}
              currentDoor={currentDoor}
              model={model}
              usages={usages}
              totals={totals}
              style={{ gridColumn, gridRow: index + 2 }}
              key={limitType}
            />
          )
        }
        <div
          className={classes.background + (gridColumn % 2 === 0 ? ' even' : ' odd') + (highlight ? ' highlight' : '')}
          style={{ gridColumn: gridColumn }}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateEntityAction, deleteDoorAction })(injectSheet(style)(DoorConfiguration))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/index.js